/* ACEPLORE · module-blog.js — blog listing enhancements.
   Custom element <lumina-blog-filter>: the mobile topic <select> navigates to the
   chosen tag URL. Chip links work without JS (progressive enhancement). */
(function () {
  'use strict';

  if (customElements.get('lumina-blog-filter')) return;

  class LuminaBlogFilter extends HTMLElement {
    constructor() {
      super();
      this._onChange = this._onChange.bind(this);
    }

    connectedCallback() {
      this.select = this.querySelector('[data-blog-tag-select]');
      if (this.select) {
        this.select.addEventListener('change', this._onChange);
      }
    }

    disconnectedCallback() {
      if (this.select) {
        this.select.removeEventListener('change', this._onChange);
      }
    }

    _onChange(event) {
      var url = event.target && event.target.value;
      if (!url) return;
      try {
        window.location.assign(url);
      } catch (e) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('lumina-blog-filter')) customElements.define('lumina-blog-filter', LuminaBlogFilter);
})();
